import { ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { SupportedFeaturesAccessFunctions } from 'data/supportedFeatures/supportedFeatures.types';
import getAccessFunctionTypeValueGetter from 'utils/valueGetters/getAccessFunctionTypeValueGetter';
import cloneDeep from 'lodash.clonedeep';

export function setDistributorAfTypeValueGetter(
  accessFunctions: SupportedFeaturesAccessFunctions,
  distributorColumnDefs: ColGroupDef[],
): ColGroupDef[] {
  const clonedDistributorColumnDefs = cloneDeep(distributorColumnDefs);

  if (Object.keys(accessFunctions).length > 0) {
    const typeColumnDef = clonedDistributorColumnDefs[0].children.find((entry) => (entry as ColDef).field === 'afType');
    if (typeColumnDef) {
      (typeColumnDef as ColDef).valueGetter = getAccessFunctionTypeValueGetter(accessFunctions);
    }
  }

  return clonedDistributorColumnDefs;
}
